module.exports = __webpack_public_path__ + "static/philosophy1-ee84f13c2a379443239e9a5a5fbbc967.gif";